var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('Layout', [_vm.loading || _vm.error ? _c('LoaderIcon', {
    attrs: {
      "error": _vm.error
    }
  }) : _c('div', [_c('div', {
    class: _vm.$style.viewContainer
  }, [_c('div', {
    class: _vm.$style.awardWinnersContainer
  }, [_c('div', {
    class: _vm.$style.titleHeaderContainer
  }, [_c('BaseTitle', {
    staticClass: "color-primary-blue",
    class: _vm.$style.title
  }, [_vm._v("Awards")]), _c('BaseSelect', {
    class: _vm.$style.yearSelect,
    attrs: {
      "name": "Date",
      "options": _vm.getYearOptions,
      "data-awards-year-select": ""
    },
    on: {
      "update": _vm.pickYear
    },
    model: {
      value: _vm.year,
      callback: function callback($$v) {
        _vm.year = $$v;
      },
      expression: "year"
    }
  }), _c('BaseSelect', {
    class: _vm.$style.awardSelect,
    attrs: {
      "name": "Award",
      "options": _vm.getAwardOptions,
      "data-awards-options-select": "",
      "option-text": "title",
      "option-value": "id"
    },
    on: {
      "update": _vm.pickAward
    },
    model: {
      value: _vm.selectedAwardId,
      callback: function callback($$v) {
        _vm.selectedAwardId = $$v;
      },
      expression: "selectedAwardId"
    }
  }), _c('div', {
    staticClass: "d-flex justify-content-around",
    class: _vm.$style.headerTypeSelector
  }, [_c('BaseSelector', {
    staticClass: "mr-15",
    attrs: {
      "active": _vm.awardType === 'User',
      "data-award-select-individual": ""
    },
    on: {
      "click": function click($event) {
        return _vm.pickAwardType('User');
      }
    }
  }, [_vm._v(" Individual ")]), _c('BaseSelector', {
    attrs: {
      "active": _vm.awardType === 'Office',
      "data-award-select-office": ""
    },
    on: {
      "click": function click($event) {
        return _vm.pickAwardType('Office');
      }
    }
  }, [_vm._v(" Office ")])], 1)], 1), _c('div', {
    class: _vm.$style.titleHeaderContainerMobile
  }, [_c('BaseTitle', {
    staticClass: "color-primary-charcoal",
    class: _vm.$style.title
  }, [_vm._v("Awards")]), _c('div', {
    staticClass: "mb-4 d-flex"
  }, [_c('BaseSelector', {
    staticClass: "mr-15",
    attrs: {
      "active": _vm.awardType === 'User'
    },
    on: {
      "click": function click($event) {
        return _vm.pickAwardType('User');
      }
    }
  }, [_vm._v(" Individual ")]), _c('BaseSelector', {
    attrs: {
      "active": _vm.awardType === 'Office'
    },
    on: {
      "click": function click($event) {
        return _vm.pickAwardType('Office');
      }
    }
  }, [_vm._v("Office")])], 1), _c('div', {
    staticClass: "d-flex justify-content-between"
  }, [_c('BaseSelect', {
    class: _vm.$style.yearSelect,
    attrs: {
      "name": "Date",
      "options": _vm.getYearOptions
    },
    on: {
      "update": _vm.pickYear
    },
    model: {
      value: _vm.year,
      callback: function callback($$v) {
        _vm.year = $$v;
      },
      expression: "year"
    }
  })], 1), _c('div', {
    class: _vm.$style.mobileAwardSelector
  }, _vm._l(_vm.getAwardOptions, function (award) {
    return _c('BaseSelector', {
      key: award.id,
      attrs: {
        "active": award.id === _vm.selectedAwardId
      },
      on: {
        "click": function click($event) {
          return _vm.pickAwardMobileSelector(award);
        }
      }
    }, [_vm._v(" " + _vm._s(award.title) + " ")]);
  }), 1)], 1), _c('div', {
    class: _vm.$style.awardDescriptionContainer
  }, [_c('div', {
    staticClass: "d-flex align-items-center mb-15"
  }, [_c('img', {
    class: _vm.$style.awardBadge,
    attrs: {
      "src": _vm.getSelectedAward.imageUrl,
      "alt": ""
    }
  }), _c('div', [_c('h2', {
    staticClass: "color-primary-blue m-10",
    attrs: {
      "data-award-title": ""
    }
  }, [_vm._v(_vm._s(_vm.getSelectedAward.title))]), _c('p', {
    staticClass: "p1"
  }, [_vm._v(_vm._s(_vm.getSelectedAward.description))])])])]), _c('div', {
    class: _vm.$style.awardDescriptionContainerMobile
  }, [_c('img', {
    class: _vm.$style.awardBadge,
    attrs: {
      "src": _vm.getSelectedAward.imageUrl,
      "alt": ""
    }
  }), _c('p', {
    staticClass: "p2"
  }, [_vm._v(_vm._s(_vm.getSelectedAward.description))])]), _vm.loadingAwardWinners ? _c('LoaderIcon', {
    staticClass: "mt-5"
  }) : _vm._e(), !_vm.loadingAwardWinners ? _c('div', {
    class: _vm.$style.awardWinners
  }, _vm._l(_vm.awardWinners, function (awardWinner) {
    return _c('AwardWinner', {
      key: awardWinner.id,
      attrs: {
        "award-winner": awardWinner,
        "is-club-award": _vm.getSelectedAward.isClubAward,
        "is-rank-award": _vm.getSelectedAward.isRankAward
      }
    });
  }), 1) : _vm._e()], 1)])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }